import React from 'react';
import './AboutOld.css';

const AboutOld = () => {
  return (
    <div className="about-page-old">
      <section className="about-hero-old">
        <div className="about-hero-content-old">
          <h1 className="about-title-old">About Miyel</h1>
        </div>
      </section>

      <section className="mission-section-old">
        <div className="content-container-old">
          <h2>Mission</h2>
          <blockquote>
            "To safeguard children's lives by providing innovative, reliable technology that prevents vehicular hyperthermia and gives parents peace of mine."
          </blockquote>
          <div className="section-image-old">
            <img src="/Baby1.png" alt="Mission" />
          </div>
        </div>
      </section>

      <section className="vision-section-old">
        <div className="content-container-old">
          <h2>Vision</h2>
          <blockquote>
            "To create a world where no child is lost to preventable vehicular hyperthermia, where technology serves as a guardian angel for families."
          </blockquote>
          <div className="section-image-old">
            <img src="/Baby2.png" alt="Vision" />
          </div>
        </div>
      </section>

      <section className="values-section-old">
        <div className="content-container-old">
          <h2>Core Values</h2>
          <div className="values-grid-old">
            <div className="value-item-old">
              <h3>Child Safety First</h3>
              <p>Every decision prioritizes the protection of children</p>
            </div>
            <div className="value-item-old">
              <h3>Innovation & Reliability</h3>
              <p>Cutting-edge technology you can trust</p>
            </div>
            <div className="value-item-old">
              <h3>Peace of Mine</h3>
              <p>Empowering parents with confidence and security</p>
            </div>
            <div className="value-item-old">
              <h3>Intelligent Design</h3>
              <p>Simple, intuitive solutions for complex problems</p>
            </div>
            <div className="value-item-old">
              <h3>Prevention Over Response</h3>
              <p>Proactive protection before emergencies occur</p>
            </div>
            <div className="value-item-old">
              <h3>Trust & Transparency</h3>
              <p>Open, honest communication with our families</p>
            </div>
          </div>
          <div className="section-image-old">
            <img src="/Baby3.png" alt="Core Values" />
          </div>
        </div>
      </section>

      <section className="founder-section-old">
        <div className="content-container-old">
          <h2>Founder & CEO</h2>
          <div className="founder-content-old">
            <div className="founder-image-old">
              <img src="/api/placeholder/300/300" alt="Courtne Matthews" />
            </div>
            <div className="founder-info-old">
              <h3>Courtne Matthews</h3>
              <p className="founder-title-old">Founder & CEO</p>
              <p>Dedicated to creating innovative safety solutions that protect families and give parents the peace of mine they deserve.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutOld;
